import {AccessibilityErrorFilled} from "@fluentui/react-icons";
import {Column, Row} from "./Layout";
import {useUserStore} from "../../../stores/useUserStore";
import {useEffect} from "react";

export default function AccessDeniedPage () {

    const resetUserInfo = useUserStore(state => state.resetUserData)

    useEffect(()=>{
        resetUserInfo()
    },[])

    return <Column gap={'16px'} alignItems={'center'} justifyContent={'center'}>
        <div style={{height: '96px'}}/>
        <AccessibilityErrorFilled fontSize={'200px'} color={'red'}/>
        <Row>
            비정상적인 접근입니다.
        </Row>
    </Column>

}